import { resultToFailed, resultToSuccess } from '../Helper'
import purchaseApi from '../PurchaseApi'

export const getInvoiceImageUrl = async (invoiceKey) => {
  try {
    const result = await purchaseApi.get(`/invoices/image/${invoiceKey}`)
    return resultToSuccess(result)
  } catch (e) {
    return resultToFailed(e)
  }
}
